import { render } from "./AppFooter.vue?vue&type=template&id=2134ef17"
const script = {}
script.render = render

export default script